import { Component, ElementRef, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, OrderCustomerInfo, OrderCustomerModel, ChecklistRepurchaseModel } from 't4core';

@Component({
    selector: 'why-not-repurchased',
  templateUrl: './ChecklistRepurchaseDialog.html',
  styleUrls: ['./ChecklistRepurchaseDialog.css']
})
export class ChecklistRepurchaseDialog extends DialogBase implements OnInit {
  public vehicleId: string;
  public checklist: ChecklistRepurchaseModel;
  public isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ChecklistRepurchaseDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ChecklistRepurchaseDialog");
    this.vehicleId = data.vehicleId;
  }

  public async ngOnInit() {
    this.isLoading = true;
    var result = await this.Api.get<ChecklistRepurchaseModel>("/TurboOrder/ChecklistRepurchase", { vehicleId: this.vehicleId });
    this.checklist = result;
    this.isLoading = false;
  }

  public static async open(dialog: MatDialog, vehicleId: string) {
    var dlg = dialog.open(ChecklistRepurchaseDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "500px",
      data: {
        vehicleId: vehicleId
      }
    });
  }
}
